module.exports = __webpack_public_path__ + "static/media/intro.f4c25cca.mp3";